export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/insur/cat',
		name: 'NbuInsurCat',
		title: {
			single: 'NbuInsurCat',
			plural: 'NbuInsurCats'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "U",
				"code": null,
				"name": "Юридична особа",
				"caption": "Юридична особа",
				"isBlocked": false
			},
			{
				"id": "F",
				"code": null,
				"name": "Фізична особа",
				"caption": "Фізична особа",
				"isBlocked": false
			},
			{
				"id": "P",
				"code": null,
				"name": "Фізична особа-підприємець",
				"caption": "Фізична особа-підприємець",
				"isBlocked": false
			}
		],
	},
}
